/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Discardchanges1Inputs */

const en_discardchanges1 = /** @type {(inputs: Discardchanges1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Discard Changes`)
};

const de_discardchanges1 = /** @type {(inputs: Discardchanges1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Änderungen verwerfen`)
};

/**
* | output |
* | --- |
* | "Discard Changes" |
*
* @param {Discardchanges1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const discardchanges1 = /** @type {((inputs?: Discardchanges1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Discardchanges1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_discardchanges1(inputs)
	return de_discardchanges1(inputs)
});
export { discardchanges1 as "discardChanges" }